export default "__VITE_ASSET__BxZnl1ls__"